export default function decodeContactData(data = '') {
  if (!data) {
    return {};
  }
  return JSON.parse(window.atob(data));
}
